import type { NavigationalLinkConfig } from './NavigationalLink'

export interface AccountRouterNavigationalLinkConfig
  extends NavigationalLinkConfig {
  showIfMinor: boolean
}

export const AccountRouterNavigationLinks: AccountRouterNavigationalLinkConfig[] =
  [
    {
      label: 'Profile',
      path: 'profile',
      showIfMinor: true
    },
    {
      label: 'My subscription',
      path: 'subscription',
      showIfMinor: true
    },
    {
      label: 'Notifications',
      path: 'notifications',
      showIfMinor: false
    },
    {
      label: 'Refer a friend',
      path: 'referrals',
      showIfMinor: false
    }
  ]
